import type { Plugin } from 'tippy.js';

/**
 * Plugin Tippy : masque l'infobulle dès qu'un défilement a lieu (page ou n'importe
 * quel conteneur, d'où l'écoute en capture). Sans lui, Popper recale l'infobulle
 * sur son élément et elle « défile » avec le contenu.
 * Le défilement interne de l'infobulle elle-même (contenu long) est ignoré.
 */
export const masquerAuDefilement: Plugin = {
  name: 'masquerAuDefilement',
  fn(instance) {
    const surDefilement = (event: Event): void => {
      if (event.target instanceof Node && instance.popper.contains(event.target)) {
        return;
      }
      instance.hide();
    };
    const retirer = (): void => document.removeEventListener('scroll', surDefilement, true);

    return {
      onShow() {
        document.addEventListener('scroll', surDefilement, { capture: true, passive: true });
      },
      onHide: retirer,
      onDestroy: retirer,
    };
  },
};
